import clsx from 'clsx';

import { TLanguagesConfigItem } from '@northladder/utilities';

import { useHrefOptions } from '../../../hooks';
import { Link } from '../../../routing';

import { FlagIcon } from '../../Flags';

interface ISetLocaleCTAProps {
  /**
   * className for css configuration
   */
  className?: string;
  /**
   * A list of items for the dropdown.
   * TODO: Look into this error
   */
  language?: TLanguagesConfigItem;
}

/**
 * -----------------------------------------------------------------------------
 * This provides a CTA that switches the language to the target one.
 * Note that this will only be present if just two locales are present.
 *
 * - It displays the country flag alongside the locale name.
 * - See also `LocaleMenu`, shown when more than 2 locales are active.
 */
export function SetLocaleCTA({ className, language }: ISetLocaleCTAProps) {
  const { href } = useHrefOptions();

  if (!language) return null;

  return (
    <Link
      className={clsx(
        'z-index-20 hover:bg-primary-50 focus:ring-primary-100 focus:hover:bg-primary-200',
        'focus:outline-hidden inline-flex w-full items-center justify-between',
        'rounded-3xl border border-gray-200 bg-white p-2 text-sm font-normal',
        'focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100',
        'rtl:text-xs 2xl:rounded-3xl',
        className
      )}
      href={href}
      locale={language.locale}
    >
      <FlagIcon className="shrink-0 rounded-lg" id={language.icon} size={22} />
      {language.label}
    </Link>
  );
}
